module.exports = __webpack_public_path__ + "img/2333fa0.jpg";